import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

export default function PaymentRequiredView() {
  return (
    <div className="flex w-full flex-grow flex-col items-center justify-center gap-5 px-4 text-center md:pt-0">
      <div className="">
        <ExclamationTriangleIcon className="m-auto h-[120px] text-orange-900" />
      </div>
      <div className="flex flex-col gap-2 text-lg">
        <div className="font-caudex font-bold">Account suspended</div>
        <div className="font-nunito max-w-[400px] text-gray-500">
          Please contact your administrator or iWarranty support team at{' '}
          <a href="mailto: support@iwarranty.co">support@iwarranty.co</a>
        </div>
      </div>
    </div>
  );
}
